module.exports = __webpack_public_path__ + "img/image31.dc9c2f7a.jpeg";